import { shouldIgnoreEntity } from './helpers/shouldIgnoreEntity';
/**
 * Extract selected schemas from the OpenAPI document.
 */
export function filterSelectedOpenAPISchemas(schema, selectedSchemas) {
    const componentsSchemas = schema.components?.schemas ?? {};
    // Preserve the order of the selected schemas
    return selectedSchemas
        .map((name) => {
        const schema = componentsSchemas[name];
        if (schema && !shouldIgnoreEntity(schema)) {
            return {
                name,
                schema,
            };
        }
        return null;
    })
        .filter((schema) => !!schema);
}
